// Function added zero
export const getPadTime = (time) => time.toString().padStart(2, '0');